$(function () {
    $('[data-date]').each((i, el) => {
        const date = $(el).data('date');
        const start = moment(date.split('-')[0], 'YYYY/MM/DD').format('YYYY-MM-DD');
        const end = moment(date.split('-')[1], 'YYYY/MM/DD').format('YYYY-MM-DD');

        if (!moment().isBetween(start, end, 'day', '[]')) {
            $(el).remove();
        }
    });
    $('.card-date').each((i, el) => {
        const date = $(el).text();
        const start = moment(date.split('-')[0], 'YYYY/MM/DD').format('YYYY-MM-DD');
        const end = moment(date.split('-')[1], 'YYYY/MM/DD').format('YYYY-MM-DD');

        if (!moment().isBetween(start, end, 'day', '[]')) {
            $(el).closest('.card').remove();
        }
    });

    // 輪播
    const wrapperNode = document.querySelector('.embla');
    const viewportNode = wrapperNode.querySelector('.embla__viewport');
    const prevButtonNode = wrapperNode.querySelector('.embla__prev');
    const nextButtonNode = wrapperNode.querySelector('.embla__next');
    const dotsNode = wrapperNode.querySelectorAll('.embla__dot');

    const emblaApi = EmblaCarousel(
        viewportNode,
        { loop: true },
        [EmblaCarouselAutoplay({
            delay: 5000,
            stopOnInteraction: false
        })]
    );

    const autoplay = emblaApi.plugins().autoplay;
    autoplay?.play();

    // 左右按鈕
    prevButtonNode.addEventListener('click', () => {
        emblaApi.scrollPrev()
        autoplay?.reset();
    });
    nextButtonNode.addEventListener('click', () => {
        emblaApi.scrollNext()
        autoplay?.reset();
    });

    // dots 點擊切換
    dotsNode.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            emblaApi.scrollTo(index)
            autoplay?.reset();
        });
    });

    // 更新 dots 狀態
    const updateDots = () => {
        const selectedIndex = emblaApi.selectedScrollSnap();
        dotsNode.forEach((dot, idx) => {
            dot.classList.toggle('-active', idx === selectedIndex);
        });
    };

    emblaApi.on('select', updateDots);
    updateDots(); // 初始化

    // tab
    $('[data-tab-btn]').on('click.tab', function (e) {
        e.preventDefault();
        var val = $(this).data('tabBtn');
        $('[data-tab-btn], [data-tab-content], .nodata').removeClass('-active');
        $(this).addClass('-active');
        if (val === 'all') {
            $('[data-tab-content]').addClass('-active');
        } else if ($('[data-tab-content="' + val + '"]').length === 0) {
            $('.nodata').addClass('-active');
        } else {
            $('[data-tab-content="' + val + '"]').addClass('-active');
        }

        let titStr = '';
        switch (val) {
            case 'all':
                titStr = '活動總覽';
                break;
            case 'TaiwanPay':
                titStr = '台灣Pay';
                break;
            case 'LINEPayMoney':
                titStr = 'LINE Pay Money';
                break;
            case 'pxpayplus':
                titStr = '全支付';
                break;
            case 'icashPay':
                titStr = 'icash Pay';
                break;
            case 'iPASSMONEY':
                titStr = 'iPASS MONEY';
                break;
            case 'easy_wallet':
                titStr = '悠遊付';
                break;
            case 'plus_pay':
                titStr = '全盈+PAY';
                break;
            case 'opay':
                titStr = '歐付寶';
                break;
            case 'ticket':
                titStr = '數位券';
                break;

            default:
                titStr = '活動總覽';
                break;
        }
        $('.event-tit').find('div').text(titStr);
    });

    if (window.location.hash) {
        $(`[data-tab-btn="${window.location.hash.split('#')[1]}"]`).trigger('click.tab');
    } else {
        $(`[data-tab-btn="all"]`).trigger('click.tab');
    }
    window.addEventListener('hashchange', () => {
        $(`[data-tab-btn="${window.location.hash.split('#')[1]}"]`).trigger('click.tab');
        $('body').removeClass('-menuOpen');
    });
});